import { WhatsApp } from "@mui/icons-material";
import { Icon, IconButton, Tooltip } from "@mui/material";
import SuiTypography from "components/SuiTypography";
import TableAction from "containers/table-action";
import { globaleDateTimeFormatter } from "utils/helper";
import moment from "moment";
import { updateFirstLetter } from "utils/helper";

export const SuperAdminRows = (clientArray, user, setInvoiceUID) => {
  const rows_ = clientArray.map((item, index) => {
    const startDate = item?.activeSubscription?.startDate?.seconds
      ? moment.unix(item.activeSubscription.startDate.seconds)
      : null;

    const endDate = startDate
      ? startDate
          .clone()
          .add(item?.activeSubscription?.monthOfSubscription || 0, "months")
      : null;

    return {
      "S.no": (
        <SuiTypography
          variant="button"
          fontWeight="medium"
          style={{ textAlign: "center" }}
        >
          {index + 1}
        </SuiTypography>
      ),

      "Client Name": (
        <SuiTypography
          variant="button"
          fontWeight="medium"
          style={{ color: "#17C1E8" }}
        >
          {item?.name}
        </SuiTypography>
      ),

      Email: (
        <Tooltip title={item?.email} placement="top">
          <SuiTypography variant="button" fontWeight="medium">
            {item?.email?.length > 15
              ? `${item?.email?.slice(0, 15)}...`
              : item?.email}
          </SuiTypography>
        </Tooltip>
      ),

      "Subscription Start": (
        <SuiTypography variant="button" fontWeight="medium" style={{ textAlign: "center" }}>
          {startDate ? globaleDateTimeFormatter(startDate, "date") : "N/A"}
        </SuiTypography>
      ),

      "Subscription End": (
        <SuiTypography variant="button" fontWeight="medium">
          {endDate ? globaleDateTimeFormatter(endDate, "date") : "N/A"}
        </SuiTypography>
      ),
      Status: (
        <SuiTypography
          variant="button"
          fontWeight="medium"
          style={{ color: item.status === "inactive" ? "Red" : "" }}
        >
          {updateFirstLetter(item.status)}
        </SuiTypography>
      ),
      Plan: (
        <SuiTypography variant="button" fontWeight="medium">
          {item?.activeSubscription?.plan ?? "N/A"}
        </SuiTypography>
      ),

      "Subscription Amount": (
        <SuiTypography variant="button" fontWeight="medium" style={{ textAlign: "right" }}>
          {item?.payment?.[item.payment.length - 1]?.amount 
            ? `₹${item.payment[item.payment.length - 1].amount}` 
            : "N/A"}
        </SuiTypography>
      ),

      Phone: (
        <>
          <SuiTypography variant="button" fontWeight="medium">
            {item?.phoneNumber}
          </SuiTypography>
          <IconButton
            size="small"
            style={{ padding: "3px", marginLeft: "5px" }}
            onClick={() => {
              window.open(`https://wa.me/${item?.phoneNumber}`, "_blank");
            }}
          >
            <WhatsApp style={{ color: "#075e54" }} />
          </IconButton>
        </>
      ),

      "Download Invoice": (
        <TableAction downloadHandler={() => setInvoiceUID(item.id)} />
      ),
    };
  });

  return rows_;
};
